import Message from "../../message";
import {useMainStore} from "@/store";

export default class MemberVipPointsGained extends Message
{
    handle()
    {
        useMainStore().INCREMENT_MEMBER_VIP_POINTS(this.message);
    }
}
